import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-alert-modal-ok',
  templateUrl: './alert-modal-ok.component.html',
  styleUrls: ['./alert-modal-ok.component.scss']
})
export class AlertModalOkComponent implements OnInit {
  @Input() MessageText: string;
  @Input() HeaderText: string;
  @Output() closeModalClick = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  modalClose() {
    this.closeModalClick.emit();
  }
}
